import { network } from "../config";
import {
  DiscountPromocode,
  NewDiscountPromocode,
  PromocodesFilters,
  PromocodesParamsAvailable,
} from "../types/Promocodes";
import TypeDefaultResponse from "../types/TypeDefaultResponse";
import { TypeUpdatedUserInfo } from "../types/TypeUsers";
import url from "../utils/formApiUrl";
import customKy from "./kyExtend";

const { promocodes } = network;

const baseURL = process.env.REACT_APP_HTTP_CONNECTION_STRING + "promocodes/";

const getAuthHeader = (token: string) => {
  return { Authorization: `Bearer ${token}` };
};

export default class PromocodesApi {
  static async createDiscountPromocode(
    token: string,
    newPromocode: NewDiscountPromocode
  ): Promise<
    TypeDefaultResponse & {
      promocode: DiscountPromocode;
    }
  > {
    return await customKy
      .post(url(baseURL, promocodes.createDiscountPromocode), {
        headers: getAuthHeader(token),
        json: { newPromocode },
        timeout: 30000,
      })
      .then((res) => res.json());
  }

  static async updateDiscountPromocode(
    token: string,
    updateData: TypeUpdatedUserInfo
  ): Promise<
    TypeDefaultResponse & {
      promocode?: DiscountPromocode;
    }
  > {
    return await customKy
      .patch(
        url(baseURL, promocodes.updateDiscountPromocode, {
          id: updateData._id,
        }),
        {
          headers: getAuthHeader(token),
          timeout: 30000,
          json: { updateData },
        }
      )
      .then((res) => res.json());
  }

  static async deleteDiscountPromocode(
    token: string,
    id: string
  ): Promise<TypeDefaultResponse> {
    return await customKy
      .delete(
        url(baseURL, promocodes.deleteDiscountPromocode, {
          id: id,
        }),
        {
          headers: getAuthHeader(token),
          timeout: 30000,
        }
      )
      .then((res) => res.json());
  }

  static async getDiscountPromocodes(
    token: string,
    filters: PromocodesFilters
  ): Promise<
    TypeDefaultResponse & {
      promocodes?: DiscountPromocode[];
      paramsAvailable?: PromocodesParamsAvailable;
    }
  > {
    return await customKy
      .post(url(baseURL, promocodes.getDiscountPromocodes), {
        headers: getAuthHeader(token),
        json: { filters },
        timeout: 30000,
      })
      .then((res) => res.json());
  }
}
